/**
 * Converts an enum value to a formatted string.
 *
 * @param value - The input enum value to be formatted.
 * @returns Formatted enum string.
 *
 * @example
 * toFormattedEnumString('VEHICLE_DAMAGE'); // Output: 'Vehicle Damage'
 * toFormattedEnumString('VEHICLE_DAMAGE_RECORD_CATEGORY'); // Output: 'Vehicle Damage Record Category'
 */
export function toFormattedEnumString(value: string): string {
	return value
		? value
				.split('_')
				.map(
					(word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
				)
				.join(' ')
		: '';
}
